export default __webpack_public_path__ + "static/media/slider_image_01-xs@2x.39cf2209.webp";